import React, { useEffect, useState } from 'react';
import Hero from "../components/Hero";
import './Home.css';
import Tittle from "../components/Tittle";
import Card from "../components/Card";
import Card2 from "../components/Card2";
import Footer from "../components/Footer";
import client from '../contenful/client';
import Fig from "../components/Fig";
import Btn from '../components/Btn';
import ScrollEffect from '../components/ScrollEffect';


const Home = () => {
  const [home, setHome] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const entries = await client.getEntries({ content_type: "homePage" });
        console.log("Fetched Contentful Entries:", entries);
        setHome(entries.items);
      } catch (err) {
        console.error("Error fetching Contentful data:", err);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {home.map((item, index) => {
        console.log("Current Entry Fields:", item.fields);

        // Extracting Data for Hero Section
        const brandStoryImage = item.fields.brandStoryImage?.fields.file.url;
        const images = item.fields.homebgImage.map((image) => ({
          url: image.fields.file.url,
          title: image.fields.title || 'No Title',
        }));
        const description1 = item.fields.description1;
        const description2 = item.fields.description2;

        // Extracting Data for Services Section
        const services = item.fields.servicesCard?.map((service, serviceIndex) => ({
          image: service.fields.file.url,
          title: service.fields.title,
          desc: service.fields.description,
          hoverDescription: item.fields[`servicesHoverDesc${serviceIndex + 1}`] || 'Default Hover Description',
        }));

        // Extracting Data for Projects Section
        const projects = item.fields.projectCard?.map((project, projectIndex) => ({
          image: project.fields.file.url,
          title: project.fields.title,
          desc: project.fields.description,
          hoverDescription: item.fields[`projectHoverDesc${projectIndex + 1}`] || 'Default Project Description',
        }));

        // Extracting Data for Publish Section
        const publishs = item.fields.publishCard?.map((publish, publishIndex) => ({
          image: publish?.fields?.file.url || '',
          title: item.fields.publishCardTitle?.[publishIndex]?.fields?.file?.url || "",
          description: publish?.fields?.description || "No Description",
        }));
        const figs = [
          {
            number: item.fields?.keyFigNum || "Default Number 1", // Safe access with optional chaining
            description: item.fields?.keyFigDesc || "Default Description 1", // Safe access with optional chaining
          },
          {
            number: item.fields?.keyFigNum2 || "Default Number 2", // Safe access with optional chaining
            description: item.fields?.keyFigDesc2 || "Default Description 2", // Safe access with optional chaining
          },
          {
            number: item.fields?.keyFigNum3 || "Default Number 3", // Safe access with optional chaining
            description: item.fields?.keyFigDesc3 || "Default Description 3", // Safe access with optional chaining
          },
          {
            number: item.fields?.keyFigNum4 || "Default Number 4", // Safe access with optional chaining
            description: item.fields?.keyFigDesc4 || "Default Description 4", // Safe access with optional chaining
          },
        ];
        

        return (
          <div key={index}>
            {/* Hero Section */}
            
            <Hero
              images={images}
              description1={description1}
              description2={description2}
              brandStoryImage={brandStoryImage}
            />

            {/* Services Section */}
            <div className="services">
            
              <Tittle title="SERVICES" />
              <ScrollEffect fadeType= "fade-down">

              
              <div className="card-sec">
                {services?.map((service, serviceIndex) => (
                  <Card
                    key={serviceIndex}
                    image={service.image}
                    title={service.title}
                    description1={service.desc}
                    description2={service.hoverDescription}
                  />
                ))}
              </div>
              </ScrollEffect>

              {/* Key Figures Section */}
              

              
              <div className="key-fig">
                <Tittle title="KEY FIGURES" />
                
                <div className="fig-sec">
                  {figs?.map((fig, figIndex) => (
                    <Fig
                      key={figIndex}
                      number={fig.number + "+"}
                      desc = {fig.description}
                      
                    />
                  ))}
                  
                </div>
               
              </div>
              
              {/* Projects Section */}
              <div className="projects">
                <Tittle title="PROJECTS" />
                <div className="card-sec2">
                  {projects?.map((project, projectIndex) => (
                    <Card
                      key={projectIndex}
                      image={project.image}
                      title={project.title}
                      description1={project.desc}
                      description2={project.hoverDescription}
                      isProject={true}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Contact Section */}
            <div className="Contact">
              <div className="grp1">
                <ScrollEffect fadeType= "fade-up">
                 <h1 className="contact-desc">Want to do a project with us? <br/> contact us now.</h1>
                
                <Btn />
                </ScrollEffect>
              </div>
            </div>

            {/* Publish Section */}
            <div className="publish services">
              <Tittle title="WE ARE PUBLISHED" />
              <ScrollEffect fadeType= "fade-up">
              <div className="card-sec3">
                {publishs?.map((publish, publishIndex) => (
                  <Card2
                    key={publishIndex}
                    image={publish.image}
                    image2={publish.title}
                    desc={publish.description}
                    isProject={true}
                  />
                ))}
              </div>
              </ScrollEffect>
              
            </div>
          </div>
        );
      })}

      {/* Footer Section */}
      <div className="footer-sec">
        <Footer />
      </div>
    </>
  );
};

export default Home;
